import './SectionCard.css';

import { getSectionsInstitutions } from '../../../services/getSectionsInstitutions';
import { useSelector } from 'react-redux';
import { filterSectionsByTitle } from '../../../utils/filterSectionsByTitle';
import { useRedirect } from '../../../hooks/useRedirect';
// Translate
import { useTranslation } from 'react-i18next';
import { FaAngleRight } from 'react-icons/fa';

const SectionCard = () => {
	const { t } = useTranslation();
	const { redirect } = useRedirect();
	const { institutionCode, ebooksAccess } = useSelector(
		(state) => state.institution,
	);

	const dataMetasearcher = getSectionsInstitutions(
		institutionCode,
		ebooksAccess,
	)[0].data;
	const dataIndependient = getSectionsInstitutions(
		institutionCode,
		ebooksAccess,
	)[1].data;

	const data = [...dataMetasearcher, ...dataIndependient];
	const filteredSections = filterSectionsByTitle(data);

	return (
		<div className='sections-desktop'>
			{filteredSections.map((section, i) => (
				<button
					onClick={() => redirect(section.route)}
					className='flex flex-col gap-2 w-full'
				>
					<div className='w-full rounded-3xl overflow-hidden relative'>
						<div className='absolute top-0 left-0 w-full h-full z-10 hover:bg-black/50 transition-colors duration-200 flex justify-center items-center opacity-0 hover:!opacity-100'>
							<div className='bg-white text-xs md:text-sm text-black rounded-full px-4 py-2 border-none flex items-center gap-2'>
								{t('explore')}
								<div className='text-white bg-black rounded-full p-0.5'>
									<FaAngleRight />
								</div>
							</div>
						</div>
						<img
							src={section.bgImage}
							alt={section.title}
							className='w-full object-cover'
							loading='lazy'
						/>
					</div>

					<p className='text-start font-semibold text-[16px]'>
						{t(section.title)}
					</p>
				</button>
			))}
		</div>
	);
};

export default SectionCard;
